 .card {
  height: 10rem;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: translateZ(0);
  border-radius: 0.7rem;
  overflow: hidden;
  min-height: 8rem;
  height: auto;
  cursor: pointer;
}

.cards .upper {
  padding: 0.25rem 1rem;
}
.cards {
  list-style: none;
  display: grid;
  gap: 1rem;
  grid-template-columns: 50% 50%;
  justify-content: center;
  align-content: center;
  padding: 0;
  padding-bottom: 0px;
  padding-bottom: 4rem;
  margin: 0 1rem;
}

.card.aggregateCard {
  margin:0;
  box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.2);
  border-left: 0.75rem solid #492298;
  flex-grow: 1;
  width: calc(100%/3.1);
  max-width: unset;
}

.card.aggregateCard .stat {
  font-size: 3rem;
  line-height: 3.5rem;
  color: #562EA6;
}

.card.aggregateCard .ofStat {
  font-size: 1.3rem;
  line-height: 1.8rem;
  color: #4c4c4c;
}

.card.aggregateCard h2 {
  font-size: 1.25rem;
  line-height: 1.5rem;
  color: #4c4c4c;
  text-transform: uppercase;
  padding: 1rem 0;
  font-weight: 700;
}

.cards.aggregateCards {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  margin: 0 1rem 2rem;
  padding: 0;
  max-width:unset;
  flex-wrap: wrap;
}

.cards.aggregateCards .metric{
  text-transform: uppercase;
}

.card.aggregateCard.mini {
  min-height:10rem;
}

.card.aggregateCard.mini h2{
  font-size: 1rem;
}

.cards.subjectCards {
  /* display: flex; */
  /* flex-wrap: wrap; */
  gap: 1rem;
  margin: 0;
  padding: 0;
  width: 100%;
  /* grid-template-columns: minmax(1fr) !important; */
  grid-template-columns: 1fr;
  /* justify-items: flex-start; */
}

.card.subjectCard {
  margin:0;
  box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.2);
  min-width: 16rem;
  flex-grow: 1;
}

.inactive {
  background-color: #eaedf2 !important;
}

.inactive p {
  display: none;
}

p.inactiveMessage {
  display: block !important;
}

.card.subjectCard h3{
  font-size: 1.1rem;
  line-height: 1.4rem;
  color: #4c4c4c;
  text-transform: uppercase;
  font-weight: 600;
  padding: 1rem;
  border-bottom: 1px solid #d4d4d4;
}

.card.subjectCard .lowerStats{
  font-size: 0.9rem;
  line-height: 1.25rem;
  color: #4c4c4c;
  text-transform: uppercase;
  font-weight: 600;
  padding: 1rem;
}

.card .statsArea {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}

.card .statsArea svg{
  width: 65%;
}

.ribbon {
  position: absolute;
  height: 1px;
  top: 0;
  right: 0;
  text-align: center;
}

.ribbonValue {
  padding: 0.5rem 1rem;
  position: relative;
  overflow:hidden;
  top: 15px;
  right: -10px;
  transform: rotate(30deg);
  box-shadow: 2px 2px 4px #55555550;
}


.leastActive {
  background-color: #4c4c4c;
  color:white;
}

.mostActive {
  background-color: green;
  color: white;
}


.cards li, .task-card {
  height: 10rem;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* filter: drop-shadow(2px 2px 4px #55555550); */
  box-shadow: 5px 5px 4px #55555550;
  transform: translateZ(0);
  border-radius: 0.7rem;
  overflow: hidden;
}
.cards .upper {
  padding: 0.25rem 1rem;
}

.cards h2 {
  font-size: 1rem;
  line-height: 1.4rem;
  color: #606060;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cards .lower {
  padding: 0.75rem 0.5rem;
  background-color: #542262;
  color: white;
  align-items: center;
}
.spinnerGrid {
  height: 100%;
}
.gridCard {
  filter: drop-shadow(2px 2px 4px #55555550);
  background-color: white;
}

.barchartArea {
  padding: 1rem;
  padding-bottom: 1.75rem;
  background-color: #fff;
  border-radius: 1rem;
  box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.2);
  min-width: 22rem;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

@media (min-width: 35rem) {

    .cards.subjectCards {
    grid-template-columns: 1fr 1fr;
  }

}


@media (min-width: 60rem) {

  .gridCard {
    margin: 0.75rem 2.5rem 2.5rem 2.5rem;
  }
  .cards, .cards.subjectCards {
    grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
    gap: 1rem;
  }

  .cards h2 {
    font-size: 1.1rem;
    line-height: 1.5rem;
  }

}
.hiddenFilterRow {
  display: none !important;
}